<template>
    <!-- 库存盘点详情 -->
    <div>
        <content-view>
            <template slot="header">
                <div class="ml16 mb16">
                    盘点仓库：{{exParameter.warehouseName}}
                </div>
                <div class="ml16">
                    盘点时间：{{exParameter.createTime}}<span class="ml40">盘点人：{{exParameter.checkUserName}}</span>
                </div>
            </template>
            <div class="wrap-container-in">
                <a-table
                bordered
                :columns="columns"
                :dataSource="dataSource"
                :pagination="pagination"
                :rowKey="(record, index) => index"
                :loading="loading"
                @change="changePage"
                class="wrap-table"
                >
                    <template slot="useType" slot-scope="key, row, index">
                        {{['全部', '售卖', '自用'][key]}}
                    </template>
                </a-table>
            </div>
        </content-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    const columns = [
        {
            title: '商品编号',
            dataIndex: 'goodsNo'
        },
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode'
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnitName'
        },
        {
            title: '商品分组',
            dataIndex: 'goodsCategoryName'
        },
        {
            title: '使用类型',
            dataIndex: 'useType',
            scopedSlots: { customRender: 'useType'}
        },
        {
            title: '盘点前仓库库存数',
            dataIndex: 'beforeNum'
        },
        {
            title: '盘点后仓库库存数',
            dataIndex: 'afterNum',
        },
        {
            title: '备注',
            dataIndex: 'remark',
        },
    ];
    export default {
        name: 'materielInventoryCheckDetail',
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                loading: false,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                exParameter: {}
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getSelfCheckInfo();
            },
            /**
             * @getSelfCheckInfo 库存盘点详情
             */
            getSelfCheckInfo() {
                let { current, pageSize} = this.pagination;
                this.loading = true;
                this.$api.newStorage.selfCheckInfo({
                    body: {
                        id: this.$route.params.id,
                        pageNum: current,
                        pageSize: pageSize
                    }
                }).then(res => {
                    this.loading = false;
                    this.exParameter = res.exParameter;
                    if (Boolean(res) && Boolean(res.data)) {
                        this.dataSource = res.data;
                    }
                    this.pagination.total = res.total;
                }).catch( err => {
                    this.loading = false;

                })
            }
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getSelfCheckInfo();
        },
        watch: {
            
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
</style>
